import React from 'react';
import {Button, Card, Col, Form, Row, Spin, Input} from 'antd';

import {messageType, showMessages} from '../../helpers/message';
import {useUpdateBookingMutation} from '../../store/api/bookingsApi';
import {BaseError} from '../../types/apiTypes';
import {BookingNoteCardProps} from '../../types/bookingTypes';

const { TextArea } = Input;

const BookingNoteCard = ({bookingID, initialMemberNote, isDisabled}: BookingNoteCardProps) => {
    const [form] = Form.useForm();
    const [updateBookingNote, {isSuccess, isError, error, isLoading}] = useUpdateBookingMutation();

    React.useEffect(() => {
        form.setFieldValue('member-note', initialMemberNote);
    }, [form, initialMemberNote]);

    React.useEffect(() => {
        if (isSuccess) {
            showMessages('Booking Note has been successfully updated.', messageType.success);
        } else if (isError) {
            showMessages((error as BaseError).data?.message, messageType.error);
        }
    }, [error, isError, isSuccess]);

    const handleFinish = (values: {'member-note': string}) => {
        if (values['member-note'] !== initialMemberNote) {
            const requestData = {member_note: values['member-note']};
            updateBookingNote({bookingID, requestData});
        } else {
            showMessages('Nothing to update!', messageType.error);
        }
    }

    return (
        <Spin spinning={isLoading}>
            <Card>
                <Form form={form} name="update-booking-note" onFinish={handleFinish}>
                    <Form.Item name="member-note">
                        <TextArea
                            showCount
                            maxLength={500}
                            rows={4}
                            disabled={isDisabled}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Row justify="end">
                            <Col>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    disabled={isDisabled}
                                >
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Card>
        </Spin>
    );
}

export default BookingNoteCard;
